export const OPEN_CONFIRM_EVENT = 'openConfirm';
export const CLOSE_CONFIRM_EVENT = 'closeConfirm';
